import React from "react"

const Section = ({ children }) => (
  <section>
    {children}
  </section>
)

export default Section
